import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Spin } from 'antd';
import { AUTH_MODE } from '../hooks/common/useAuth.ts';
import DevShell from './DevShell.tsx';
import MsalShell from './MsalShell.tsx';
import LocalShell from './LocalShell.tsx';
import MockEntraShell from './MockEntraShell.tsx';

const Shell = AUTH_MODE === 'dev' ? DevShell
  : AUTH_MODE === 'local' || AUTH_MODE === 'mock-sso' ? LocalShell
    : AUTH_MODE === 'mock-entra' ? MockEntraShell : MsalShell;

const LogoutPage = lazy(() => import('../auth/pages/LogoutPage.tsx'));
const AccessDeniedPage = lazy(() => import('../auth/pages/AccessDeniedPage.tsx'));
const SessionTimeoutPage = lazy(() => import('../auth/pages/SessionTimeoutPage.tsx'));
const NotFoundPage = lazy(() => import('../auth/pages/NotFoundPage.tsx'));

const pageLoader = (
  <div style={{ display: 'flex', justifyContent: 'center', padding: 80 }}>
    <Spin size="large" />
  </div>
);

export function withSuspense(element: React.ReactNode) {
  return <Suspense fallback={pageLoader}>{element}</Suspense>;
}

export const notFoundRoute: RouteObject = { path: '*', element: withSuspense(<NotFoundPage />) };

export function shellRoutes(children: RouteObject[]): RouteObject[] {
  return [{
    element: <Shell />,
    children: [
      { path: '/logout', element: withSuspense(<LogoutPage />) },
      { path: '/access-denied', element: withSuspense(<AccessDeniedPage />) },
      { path: '/session-timeout', element: withSuspense(<SessionTimeoutPage />) },
      ...children,
    ],
  }];
}